import React from "react";
import { hydrate, render } from "react-dom";

import "./index.scss";
import App from "./App";

const root = document.getElementById("root");

root && (root.hasChildNodes() ? hydrate(<App />, root) : render(<App />, root));
